// extracted by mini-css-extract-plugin
export default {"container":"FormInput_container__cGEx3","valid":"FormInput_valid__VdbB3","readOnly":"FormInput_readOnly__U+dPV","label":"FormInput_label__cN-Ef","spacer":"FormInput_spacer__piqJ+"};